import mapActions from './mapActions';


export default mapActions('master_employees', {
	fetchAll_url: (id) => `/api/employees/${id}/masters_employees`,
});
